"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
(function () {
  const styles = ".interview-container {\n  display: flex;\n  flex-direction: column;\n  gap: 48px; }\n";
  const fileName = "Interview_Interview";
  const element = document.querySelector("style[data-sass-component='Interview_Interview']");
  if (!element) {
    const styleBlock = document.createElement("style");
    styleBlock.innerHTML = styles;
    styleBlock.setAttribute("data-sass-component", fileName);
    document.head.appendChild(styleBlock);
  } else {
    element.innerHTML = styles;
  }
})();
const QuestionAnswer = _ref => {
  let {
    item,
    lang,
    interviewed,
    showInterviewed
  } = _ref;
  const {
    question,
    answer
  } = item;
  return /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("p", {
    className: "sia-margin-01-bottom sia-text-05",
    lang: lang,
    dangerouslySetInnerHTML: {
      __html: question?.replace('<p>', '')?.replace('</p>', '')
    }
  }), /*#__PURE__*/_react.default.createElement("p", null, showInterviewed && /*#__PURE__*/_react.default.createElement("span", {
    className: "sia-text-04"
  }, interviewed, ": "), /*#__PURE__*/_react.default.createElement("span", {
    className: "sia-text-10",
    lang: lang,
    dangerouslySetInnerHTML: {
      __html: answer?.replace('<p>', '')?.replace('</p>', '')
    }
  })));
};
const Interview = _ref2 => {
  let {
    item,
    lang
  } = _ref2;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "interview-container sia-padding-03-bottom sia-padding-03-right"
  }, item?.question_answer?.map((el, index) => {
    return /*#__PURE__*/_react.default.createElement(QuestionAnswer, {
      key: el.id,
      item: el,
      lang: lang,
      interviewed: item.interviewed,
      showInterviewed: index === 0
    });
  }));
};
Interview.propTypes = {
  item: _propTypes.default.object.isRequired,
  lang: _propTypes.default.string.isRequired
};
Interview.defaultProps = {};
var _default = exports.default = Interview;